module.exports = __webpack_public_path__ + "static/media/circlecheckwhite.6d49034e.svg";